<!-- 首页 -->
<template>
	<div class="home">
		<el-carousel arrow="always" class="imgBanner" id="el-carousel">
			<el-carousel-item v-for="(item,index) in imgs" :key="index">
				<img :src=item.imgUrl alt="">
			</el-carousel-item>
		</el-carousel>
		
		<div v-for="(item,index) in $t('menus')"  :key="index + 'home'" class="aboutUsSingle">
			<h2 v-if="$store.state.currentLanguage == 'zh'">{{item.title1}}</h2>
			<p class ="title">{{item.title2}}</p>
			<div class="fontline"></div>
			<div class="imgLists">
				<div class="imgList" v-for="(item2,index2) in item.imgs" :key="index2 + 'case'">
					<div class="imgBox">
						<img :src=item2.imgSrc  alt="">
					</div>
					<h4>{{item2.title}}</h4>
					<div class="homeImgBtn" @click="details(item2)">{{$t('detailName')}}</div>
				</div>
			</div>
		</div>
		
		<div class="rongyu">
			<div  class="aboutUsSingle">
				<h2 v-if="$store.state.currentLanguage == 'zh'">公司荣誉</h2>
				<p class ="title">COMPANY PROFILE</p>
				<div class="fontline"></div>
			</div>
			<div class="banshi">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div v-for="item in swiperList" :key="item.id" class="swiper-slide">
							<img :src="item.imgName" alt="">
						</div>
					</div>
					<!-- <div class="swiper-pagination"></div> -->
					<div class="swiper-button-next"></div>
					<div class="swiper-button-prev"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
	export default {
	  components: {},
	  data() {
	    return {
			imgs:[
				{imgUrl:require("../assets/img/hexibanner1.jpg")},
				{imgUrl:require("../assets/img/hexibanner2.jpg")},
				{imgUrl:require("../assets/img/hexibanner3.jpg")},
				{imgUrl:require("../assets/img/hexib4.jpg")},
				{imgUrl:require("../assets/img/hexibanner5.jpg")},
				{imgUrl:require("../assets/img/hexibanner6.jpg")},
			],
			bannerHeight: 600,
      		screenWidth: 1920,
			
			swiper:null,
			swiperList:[
				{id:1,imgName:require('../assets/img/gs1.jpg')},
				{id:2,imgName:require('../assets/img/gs2.jpg')},
				{id:3,imgName:require('../assets/img/gs3.jpg')},
				{id:4,imgName:require('../assets/img/gs4.jpg')},
				{id:5,imgName:require('../assets/img/gs5.jpg')},
				{id:6,imgName:require('../assets/img/gs6.jpg')},
				{id:7,imgName:require('../assets/img/gs7.jpg')},
				{id:8,imgName:require('../assets/img/gs8.jpg')},
			]
		}
	  },
	  mounted () {
		this.getSwiper();
		this.setSize1();
		const that = this;
		// 监听浏览器窗口大小改变
		window.addEventListener('resize', function() {
		var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		that.screenWidth = width;
		that.setSize();
		}, false);
	  },
	  watch: {
		'$route.path': {
			handler(newVal, oldVal) {
				//判断newVal有没有值监听路由变化
				this.$nextTick(()=>{
					if (newVal == '/home') {
						this.getSwiper()
					}
				})
			},
			deep: true
		},
	  },
	  methods:{
		setSize1: function() {
		var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		this.screenWidth = width;
		// 图片高/宽 700/1920
		this.bannerHeight = 600 / 1920 * this.screenWidth;
		document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
		},
		setSize: function() {
		this.bannerHeight = 600 / 1920 * this.screenWidth;
		document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
		},
		getSwiper(){
			this.swiper = new Swiper(".swiper-container",{
				loop:true,//无缝
				autoplay:{//自动开始
					delay:3000,//时间间隔
					disableOnInteraction: false, //*手动操作轮播图后不会暂停*
				},
				paginationClickable: true,
				slidesPerView: 4, // 一组三个
				spaceBetween: 30, // 间隔
				// 如果需要前进后退按钮
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				// 窗口变化,重新init,针对F11全屏和放大缩小,必须加
				observer: true,
				observeParents: true,
				// 如果需要分页器
				pagination: {
					el: '.swiper-pagination',
					clickable: true, // 分页器可以点击
				},
			})
		},
		details(index){
			if(index.type == 'vr'){
				window.open(index.path, '_blank')
			}else if(index.type == 'case'){
				this.$router.push({ path: index.path })
				this.$store.state.iscur = 3//定位到所选菜单
				sessionStorage.setItem('changeId', '3');//修改session的值
				document.documentElement.scrollTop = 0;
  				document.body.scrollTop = 0;
			}
		}
	  }
	}
</script>

<style scoped lang="scss">
.home{
	background-color: #f5f5f5;
}
 .imgBanner{
	// border:1px solid red;
	width: 100%;
	min-width: 1200px;
	img{
		max-width: 100%;
		display: inline-block;
		height:auto;
	}
 }
 
 .aboutUsSingle{
	box-sizing: border-box;
	margin:100px auto;
	h2{
		text-align: center;
	}
	p.title{
		text-align: center;
		margin-bottom:10px;
	}
	.fontline{
		width:140px;
		height:3px;
		margin:0 auto;
		background-color: #409eff;
		margin-bottom:50px;
	}
  }
 .imgLists{
	width:1200px;
	// border:1px solid red;
	margin: 0 auto;
	display: flex;
	.imgList{
		width:33.33%;
		background-color: #fff;
		padding:15px;
		box-sizing: border-box;
		border:1px solid #ebebeb;
		margin: 10px;
		border-radius: 5px;
		.imgBox{
			width: 100%;
			height:250px;
			margin-bottom:20px;
			border-bottom:1px solid #ebebeb;
			overflow: hidden;
			img{
				width:100%;
				height: 100%;
				transition: all 0.5s;
			}
		}
		h4{
			font-size: 18px;
			font-weight: normal;
			text-align: center;
		}
		.homeImgBtn{
			width:70%;
			height:40px;
			margin: 0 auto;
			line-height: 40px;
			color:#fff;
			cursor: pointer;
			background-color: #409eff;
			text-align: center;
			margin-top:40px ;
			margin-bottom:40px ;
			transition: all 0.5s;
		}
		.homeImgBtn:hover{
			background-color: #63b0ff;
			border-radius:20px;
		}
	}
	.imgList:hover{
		// cursor: pointer;
		img{
			transform:scale(1.2);
		}
	}
 }
 .rongyu{
	background-color: #fff;
	
	width:100vw;
	padding: 20px;
	padding-bottom:100px;
	box-sizing: border-box;
 }

.banshi {
    width: 1210px;
    margin: 0 auto;
    padding:0px 0 70px 0;
    .swiper-slide {
        position: relative;
         background-color: #F7F8FA;
    }
	
}
</style>